  const header = document.querySelector(".header");

  window.addEventListener("scroll", () => {
    if (!header) return;

    if (window.scrollY > 80) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }
  });

// GSAP animates the menus where a page loads it. Pages that don't (e.g. the
// visa-details pages) get the same open/close behaviour with CSS transitions,
// so the menus never depend on GSAP being present.
const hasGsap = typeof window.gsap !== "undefined";

// ===== DESKTOP DROPDOWN =====
document.querySelectorAll(".has-dropdown").forEach(menu => {

    const dropdown = menu.querySelector(".dropdown-menu-custom");
    if (!dropdown) return;

    let timeout;

    function showMenu() {

        clearTimeout(timeout);

        if (!hasGsap) {
            dropdown.style.transition = "opacity .25s ease, transform .25s ease";
            dropdown.style.visibility = "visible";
            dropdown.style.pointerEvents = "auto";
            dropdown.style.opacity = "1";
            dropdown.style.transform = "translateY(0)";
            return;
        }

        gsap.to(dropdown, {
            opacity: 1,
            y: 0,
            duration: 0.25,
            onStart: () => {
                dropdown.style.visibility = "visible";
                dropdown.style.pointerEvents = "auto";
            }
        });
    }

    function hideMenu() {

        timeout = setTimeout(() => {

            if (!hasGsap) {
                dropdown.style.opacity = "0";
                dropdown.style.transform = "translateY(10px)";
                dropdown.style.pointerEvents = "none";
                timeout = setTimeout(() => { dropdown.style.visibility = "hidden"; }, 200);
                return;
            }

            gsap.to(dropdown, {
                opacity: 0,
                y: 10,
                duration: 0.2,
                onComplete: () => {
                    dropdown.style.visibility = "hidden";
                    dropdown.style.pointerEvents = "none";
                }
            });

        }, 150);
    }

    menu.addEventListener("mouseenter", showMenu);
    menu.addEventListener("mouseleave", hideMenu);

    dropdown.addEventListener("mouseenter", showMenu);
    dropdown.addEventListener("mouseleave", hideMenu);

});

    // ===== MOBILE MENU =====
    const menu = document.getElementById("mobileMenu");
    const hamburger = document.getElementById("hamburger");
    const closeMenu = document.getElementById("closeMenu");

    let open = false;

    // Hamburger bars: [top, middle, bottom] -> "X" when open.
    function setBars(isOpen) {
        if (!hamburger) return;
        const bars = hamburger.children;
        if (hasGsap) {
            gsap.to(bars[0], isOpen ? { rotate: 45, y: 8 } : { rotate: 0, y: 0 });
            gsap.to(bars[1], { opacity: isOpen ? 0 : 1 });
            gsap.to(bars[2], isOpen ? { rotate: -45, y: -8 } : { rotate: 0, y: 0 });
            return;
        }
        for (const bar of bars) bar.style.transition = "transform .3s ease, opacity .3s ease";
        bars[0].style.transform = isOpen ? "translateY(8px) rotate(45deg)" : "";
        bars[1].style.opacity = isOpen ? "0" : "";
        bars[2].style.transform = isOpen ? "translateY(-8px) rotate(-45deg)" : "";
    }

    function openMenu(){
      open = true;
      if (hasGsap) {
        gsap.to(menu,{y:0,duration:0.5});
        gsap.from(".mobile-menu a",{opacity:0,y:20,stagger:0.08});
      } else {
        menu.style.transition = "transform .5s ease";
        menu.style.transform = "translateY(0)";
      }
      setBars(true);
    }

    function closeMenuFunc(){
      open = false;
      if (hasGsap) {
        gsap.to(menu,{y:"-100%",duration:0.5});
      } else {
        menu.style.transition = "transform .5s ease";
        menu.style.transform = "translateY(-100%)";
      }
      setBars(false);
    }

    if (menu && hamburger) {
        hamburger.addEventListener("click",()=>{
          open ? closeMenuFunc() : openMenu();
        });
    }

    if (menu && closeMenu) closeMenu.addEventListener("click",closeMenuFunc);


    // ===== MOBILE DROPDOWN =====
    const toggle = document.getElementById("mobileServiceToggle");
    const mobileDropdown = document.getElementById("mobileDropdown");

    if (toggle && mobileDropdown) {
        toggle.addEventListener("click",(e)=>{
          e.preventDefault();
          e.stopPropagation();

          if(mobileDropdown.style.display === "flex"){
            mobileDropdown.style.display = "none";
          } else {
            mobileDropdown.style.display = "flex";
          }
        });
    }


    // ===== CLOSE MENU (EXCEPT SERVICES) =====
    if (menu) {
        document.querySelectorAll(".mobile-menu a").forEach(link => {
          link.addEventListener("click", (e) => {

            // Do NOT close when clicking Services toggle
            if(link.id === "mobileServiceToggle") return;

            closeMenuFunc();
          });
        });
    }

    //-- popup js ---//
    // Only pages that include the #sitePopup markup show it.
    const popup = document.getElementById("sitePopup");
    const closeBtn = document.getElementById("popupClose");
    const okBtn = document.getElementById("popupOkay");

    if (popup) {
        // Show popup on load
        window.addEventListener("load", () => {
            setTimeout(() => {
                popup.style.display = "flex";
            }, 500);
        });

        // Close popup
        const closePopup = () => { popup.style.display = "none"; };

        if (closeBtn) closeBtn.addEventListener("click", closePopup);
        if (okBtn) okBtn.addEventListener("click", closePopup);
    }


    /* ── FAQ ACCORDION js ───────────────────────── */
    function faqToggle(qEl){
        const item=qEl.closest('.faq-item');
        const isOpen=item.classList.contains('open');
        document.querySelectorAll('.faq-item.open').forEach(i=>{
            i.classList.remove('open');
            i.querySelector('.faq-a').style.maxHeight='0';
        });
        if(!isOpen){
            item.classList.add('open');
            item.querySelector('.faq-a').style.maxHeight=item.querySelector('.faq-a').scrollHeight+'px';
        }
    }

    /* FAQ filter (faq.html only) */
    const faqFilter = document.getElementById('faqFilter');
    if (faqFilter) {
        faqFilter.addEventListener('click',e=>{
            const btn=e.target.closest('.faq-pill');
            if(!btn)return;
            document.querySelectorAll('.faq-pill').forEach(p=>p.classList.remove('active'));
            btn.classList.add('active');
            const f=btn.dataset.fq;
            document.querySelectorAll('.faq-item').forEach(item=>{
                const match=f==='all'||item.dataset.fq===f;
                item.classList.toggle('hidden',!match);
            });
        });
    }
